import React from "react";
import { InfinitySpin } from "react-loader-spinner";
import { useLoading } from "../contexts/LoadingContext";
import "./loader.css";

const Loader = () => {
  const { isLoading } = useLoading();

  return (
    <>
      {isLoading && (
        <div className="loader-overlay">
          <div className="loader-blur" />
          <InfinitySpin
            visible={true}
            width="200"
            color="#950500"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      )}
    </>
  );
};

export default Loader;
